export enum OrderResponseType {
  TempOrder = 'tempOrder',
  Order = 'order',
  Warning = 'warning',
}
